<template>
  <div class="container">
    <div class="time-icon"></div>
    <div class="time-picker-wrapper">
      <el-radio-group class="m-[1px] time-format" v-model="timeFormat" @change="savePreferredTimeFormat">
        <el-radio-button value="hh:mm A" label="AM/PM"></el-radio-button>
        <el-radio-button value="HH:mm" label="24H"></el-radio-button>
      </el-radio-group>
      <slot></slot>
    </div>
  </div>
</template>
<script src="./timepicker-with-timeformat.js"></script>
<style lang="scss" src="./timepicker-with-timeformat.scss" scoped></style>
